/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_GET
 */
export const listFsmConnectionTechsParams = zod.object({
  "id": zod.string().uuid()
})

export const listFsmConnectionTechsResponseItem = zod.object({
  "id": zod.string().uuid(),
  "fsmConnectionId": zod.string().uuid(),
  "sourceTechId": zod.string(),
  "name": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "emailSuppression": zod.object({
  "reason": zod.string(),
  "suppressedDate": zod.string().datetime({})
}).optional(),
  "onboardingStatus": zod.enum(['Onboarded', 'Invited', 'NotInvited', 'NoEmail', 'UndeliverableEmail', 'NotPayable']),
  "isOnRoster": zod.boolean(),
  "isPayable": zod.boolean(),
  "isPayabilityDecidedByPlatform": zod.boolean(),
  "payableSetByUserId": zod.string().uuid().nullish(),
  "payableSetByName": zod.string().nullish(),
  "payableSetDate": zod.string().datetime({}).nullish(),
  "notPayableReason": zod.string().nullish(),
  "resolvedPayee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}).optional(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']).optional(),
  "isReadyToBePaid": zod.boolean(),
  "mapping": zod.enum(['Unmapped', 'AutoMappedByEmailMatch', 'ManuallyMappedByAdmin']),
  "firstInvitedAt": zod.string().datetime({}).nullish(),
  "finalInvitedAt": zod.string().datetime({}).nullish(),
  "waitingCompletedWorkCount": zod.number(),
  "payeeOrganizationCandidates": zod.array(zod.object({
  "organizationId": zod.string().uuid(),
  "name": zod.string()
})),
  "firstSeenDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({}),
  "leftRosterDate": zod.string().datetime({}).nullish()
})
export const listFsmConnectionTechsResponse = zod.array(listFsmConnectionTechsResponseItem)

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const mapFsmTechParams = zod.object({
  "id": zod.string().uuid()
})

export const mapFsmTechBody = zod.object({
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
})
})

export const mapFsmTechResponse = zod.object({
  "id": zod.string().uuid(),
  "fsmConnectionId": zod.string().uuid(),
  "sourceTechId": zod.string(),
  "name": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "emailSuppression": zod.object({
  "reason": zod.string(),
  "suppressedDate": zod.string().datetime({})
}).optional(),
  "onboardingStatus": zod.enum(['Onboarded', 'Invited', 'NotInvited', 'NoEmail', 'UndeliverableEmail', 'NotPayable']),
  "isOnRoster": zod.boolean(),
  "isPayable": zod.boolean(),
  "isPayabilityDecidedByPlatform": zod.boolean(),
  "payableSetByUserId": zod.string().uuid().nullish(),
  "payableSetByName": zod.string().nullish(),
  "payableSetDate": zod.string().datetime({}).nullish(),
  "notPayableReason": zod.string().nullish(),
  "resolvedPayee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}).optional(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']).optional(),
  "isReadyToBePaid": zod.boolean(),
  "mapping": zod.enum(['Unmapped', 'AutoMappedByEmailMatch', 'ManuallyMappedByAdmin']),
  "firstInvitedAt": zod.string().datetime({}).nullish(),
  "finalInvitedAt": zod.string().datetime({}).nullish(),
  "waitingCompletedWorkCount": zod.number(),
  "payeeOrganizationCandidates": zod.array(zod.object({
  "organizationId": zod.string().uuid(),
  "name": zod.string()
})),
  "firstSeenDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({}),
  "leftRosterDate": zod.string().datetime({}).nullish()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const unmapFsmTechParams = zod.object({
  "id": zod.string().uuid()
})

export const unmapFsmTechResponse = zod.object({
  "id": zod.string().uuid(),
  "fsmConnectionId": zod.string().uuid(),
  "sourceTechId": zod.string(),
  "name": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "emailSuppression": zod.object({
  "reason": zod.string(),
  "suppressedDate": zod.string().datetime({})
}).optional(),
  "onboardingStatus": zod.enum(['Onboarded', 'Invited', 'NotInvited', 'NoEmail', 'UndeliverableEmail', 'NotPayable']),
  "isOnRoster": zod.boolean(),
  "isPayable": zod.boolean(),
  "isPayabilityDecidedByPlatform": zod.boolean(),
  "payableSetByUserId": zod.string().uuid().nullish(),
  "payableSetByName": zod.string().nullish(),
  "payableSetDate": zod.string().datetime({}).nullish(),
  "notPayableReason": zod.string().nullish(),
  "resolvedPayee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}).optional(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']).optional(),
  "isReadyToBePaid": zod.boolean(),
  "mapping": zod.enum(['Unmapped', 'AutoMappedByEmailMatch', 'ManuallyMappedByAdmin']),
  "firstInvitedAt": zod.string().datetime({}).nullish(),
  "finalInvitedAt": zod.string().datetime({}).nullish(),
  "waitingCompletedWorkCount": zod.number(),
  "payeeOrganizationCandidates": zod.array(zod.object({
  "organizationId": zod.string().uuid(),
  "name": zod.string()
})),
  "firstSeenDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({}),
  "leftRosterDate": zod.string().datetime({}).nullish()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const setFsmTechPayabilityParams = zod.object({
  "id": zod.string().uuid()
})

export const setFsmTechPayabilityBody = zod.object({
  "isPayable": zod.boolean()
})

export const setFsmTechPayabilityResponse = zod.object({
  "id": zod.string().uuid(),
  "fsmConnectionId": zod.string().uuid(),
  "sourceTechId": zod.string(),
  "name": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "emailSuppression": zod.object({
  "reason": zod.string(),
  "suppressedDate": zod.string().datetime({})
}).optional(),
  "onboardingStatus": zod.enum(['Onboarded', 'Invited', 'NotInvited', 'NoEmail', 'UndeliverableEmail', 'NotPayable']),
  "isOnRoster": zod.boolean(),
  "isPayable": zod.boolean(),
  "isPayabilityDecidedByPlatform": zod.boolean(),
  "payableSetByUserId": zod.string().uuid().nullish(),
  "payableSetByName": zod.string().nullish(),
  "payableSetDate": zod.string().datetime({}).nullish(),
  "notPayableReason": zod.string().nullish(),
  "resolvedPayee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}).optional(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']).optional(),
  "isReadyToBePaid": zod.boolean(),
  "mapping": zod.enum(['Unmapped', 'AutoMappedByEmailMatch', 'ManuallyMappedByAdmin']),
  "firstInvitedAt": zod.string().datetime({}).nullish(),
  "finalInvitedAt": zod.string().datetime({}).nullish(),
  "waitingCompletedWorkCount": zod.number(),
  "payeeOrganizationCandidates": zod.array(zod.object({
  "organizationId": zod.string().uuid(),
  "name": zod.string()
})),
  "firstSeenDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({}),
  "leftRosterDate": zod.string().datetime({}).nullish()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const inviteFsmTechParams = zod.object({
  "id": zod.string().uuid()
})

